import { useQuery } from '@tanstack/react-query';
import { get, api } from '../../../../lib/api';

export const useGetBoard = () =>
  useQuery(['getBoard'], () => get('/api/client_admin/send/public_boards'));

export const updatePublicBoard = ({ isPublic, demoId }) => {
  return api.put(`/api/client_admin/send/public_boards/${demoId}`, {
    demo: {
      is_public: isPublic,
    },
  });
};
